import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ViaCepResponse } from '../models/viaCepResponse';

@Injectable({ providedIn: 'root' })
export class ViaCepService {
  private http: HttpClient = inject(HttpClient);

  lookup(cep: string): Observable<ViaCepResponse> {
    const digits = (cep || '').replace(/\D/g, '').padStart(8, '0');
    return this.http.get<ViaCepResponse>(
      `https://viacep.com.br/ws/${digits}/json/`
    );
  }
}
